export const showLoadingIndicator = () => {
  const overlay = document.createElement('div');
  overlay.id = 'loading-overlay';
  overlay.style.position = 'fixed';
  overlay.style.top = '0';
  overlay.style.left = '0';
  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.backgroundColor = 'rgba(57, 61, 60, 0.2)';
  overlay.style.zIndex = '9998';
  document.body.appendChild(overlay);

  const loadingIndicator = document.createElement('div');
  loadingIndicator.id = 'loading-indicator';
  loadingIndicator.style.position = 'fixed';
  loadingIndicator.style.top = '50%';
  loadingIndicator.style.left = '50%';
  loadingIndicator.style.transform = 'translate(-50%, -50%)';
  loadingIndicator.style.zIndex = '9999';
  loadingIndicator.style.width = '75px';
  loadingIndicator.style.height = '75px';

  const loadingImage = document.createElement('img');
  loadingImage.src = 'https://cdn.shopify.com/s/files/1/0689/2647/2508/files/loading-indicator.gif';
  loadingIndicator.appendChild(loadingImage);

  document.body.appendChild(loadingIndicator);
};

export const hideLoadingIndicator = () => {
  const loadingIndicator = document.getElementById('loading-indicator');
  const loadingOverlay = document.getElementById('loading-overlay');
  if (loadingIndicator && loadingOverlay) {
    document.body.removeChild(loadingIndicator);
    document.body.removeChild(loadingOverlay);
  }
};
